import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ov-page" }
const _hoisted_2 = { class: "ov-status-row" }
const _hoisted_3 = { class: "ov-sys-username" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ov-metrics" }
const _hoisted_6 = { class: "ov-metric" }
const _hoisted_7 = { class: "ov-metric-value" }
const _hoisted_8 = { class: "ov-metric" }
const _hoisted_9 = { class: "ov-metric-value" }
const _hoisted_10 = { class: "ov-metric" }
const _hoisted_11 = { class: "ov-metric-value" }
const _hoisted_12 = { class: "ov-metric" }
const _hoisted_13 = { class: "ov-metric-value" }
const _hoisted_14 = { class: "ov-grid" }
const _hoisted_15 = { class: "ov-card" }
const _hoisted_16 = { class: "ov-storage-bar-wrap" }
const _hoisted_17 = { class: "ov-storage-label" }
const _hoisted_18 = {
  key: 0,
  class: "ov-storage-warn"
}
const _hoisted_19 = { class: "ov-card" }
const _hoisted_20 = {
  key: 0,
  class: "ov-loading-row"
}
const _hoisted_21 = {
  key: 1,
  class: "ov-info-list"
}
const _hoisted_22 = { class: "ov-info-row" }
const _hoisted_23 = { class: "ov-info-row" }
const _hoisted_24 = { class: "ov-info-val" }
const _hoisted_25 = { class: "ov-info-row" }
const _hoisted_26 = { class: "ov-info-val" }
const _hoisted_27 = { class: "ov-info-row" }
const _hoisted_28 = { class: "ov-info-val" }
const _hoisted_29 = { class: "ov-info-row" }
const _hoisted_30 = { class: "ov-info-val" }
const _hoisted_31 = { class: "ov-info-row" }
const _hoisted_32 = { class: "ov-info-val" }
const _hoisted_33 = { class: "ov-card" }
const _hoisted_34 = { class: "ov-info-list" }
const _hoisted_35 = { class: "ov-info-row" }
const _hoisted_36 = { class: "ov-info-val" }
const _hoisted_37 = { class: "ov-info-row" }
const _hoisted_38 = { class: "ov-info-val" }
const _hoisted_39 = {
  key: 0,
  class: "ov-info-row"
}
const _hoisted_40 = { class: "ov-card" }
const _hoisted_41 = {
  key: 0,
  class: "ov-loading-row"
}
const _hoisted_42 = {
  key: 1,
  class: "ov-modules-grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["ov-badge", $setup.isDisabled ? 'ov-badge--suspended' : 'ov-badge--active'])
      }, _toDisplayString($setup.isDisabled ? 'Suspenso' : 'Ativo'), 3),
      _createElementVNode("span", _hoisted_3, "@" + _toDisplayString($setup.systemUsername), 1),
      _createElementVNode("button", {
        class: "ov-impersonate",
        type: "button",
        disabled: $setup.impersonating,
        title: "Entrar no sistema desta obra como administrador (suporte)",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doImpersonate && $setup.doImpersonate(...args)))
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          width: "13",
          height: "13",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }),
          _createElementVNode("polyline", { points: "10 17 15 12 10 7" }),
          _createElementVNode("line", {
            x1: "15",
            y1: "12",
            x2: "3",
            y2: "12"
          })
        ], -1)),
        _createTextVNode(" " + _toDisplayString($setup.impersonating ? 'Entrando...' : 'Entrar como admin'), 1)
      ], 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString($setup.activeUsers), 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ov-metric-label" }, "Usuários ativos", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString($setup.inactiveUsers), 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ov-metric-label" }, "Usuários inativos", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString($setup.activeProjects), 1),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ov-metric-label" }, "Projetos ativos", -1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString($setup.totalUsers), 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ov-metric-label" }, "Total de usuários", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[7] || (_cache[7] = _createStaticVNode("<h3 class=\"ov-card-title\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\"></ellipse><path d=\"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3\"></path><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\"></path></svg> Armazenamento </h3>", 1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "ov-storage-bar-fill",
            style: _normalizeStyle({ width: $setup.storagePct + '%', background: $setup.storageColor })
          }, null, 4)
        ]),
        _createElementVNode("p", _hoisted_17, [
          _createElementVNode("strong", null, _toDisplayString($setup.storageUsedLabel), 1),
          _cache[6] || (_cache[6] = _createTextVNode(" usados de ", -1)),
          _createElementVNode("strong", null, _toDisplayString($setup.storageLimitLabel), 1),
          _createTextVNode(" (" + _toDisplayString($setup.storagePct) + "%) ", 1)
        ]),
        ($setup.storagePct >= 90)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, "⚠️ Armazenamento quase cheio"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "ov-card-title" }, [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("rect", {
              x: "2",
              y: "5",
              width: "20",
              height: "14",
              rx: "2"
            }),
            _createElementVNode("line", {
              x1: "2",
              y1: "10",
              x2: "22",
              y2: "10"
            })
          ]),
          _createTextVNode(" Contrato ")
        ], -1)),
        ($setup.payLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Carregando..."))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ov-info-key" }, "Plano", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["ov-info-val ov-plan-badge", 'ov-plan--' + ($setup.payment?.plan || 'basico')])
                }, _toDisplayString($setup.planLabel($setup.payment?.plan)), 3)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ov-info-key" }, "Status pagamento", -1)),
                _createElementVNode("span", _hoisted_24, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["ov-pay-badge", $setup.payStatusClass($setup.payment?.paymentStatus)])
                  }, _toDisplayString($setup.payStatusLabel($setup.payment?.paymentStatus)), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ov-info-key" }, "Valor contrato", -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString($setup.payment?.contractValue != null ? 'R$ ' + $setup.payment.contractValue.toFixed(2) : '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ov-info-key" }, "Máx. usuários", -1)),
                _createElementVNode("span", _hoisted_28, _toDisplayString($setup.payment?.maxUsers ?? '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ov-info-key" }, "Vencimento dia", -1)),
                _createElementVNode("span", _hoisted_30, _toDisplayString($setup.payment?.paymentDay ?? '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ov-info-key" }, "Último pagamento", -1)),
                _createElementVNode("span", _hoisted_32, _toDisplayString($setup.payment?.lastPaymentAt ? $setup.formatDate($setup.payment.lastPaymentAt) : '—'), 1)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _cache[18] || (_cache[18] = _createStaticVNode("<h3 class=\"ov-card-title\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line></svg> Datas </h3>", 1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ov-info-key" }, "Início do sistema", -1)),
            _createElementVNode("span", _hoisted_36, _toDisplayString($setup.createdAtLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ov-info-key" }, "Renovação anual", -1)),
            _createElementVNode("span", _hoisted_38, _toDisplayString($setup.renewalDateLabel), 1)
          ]),
          ($setup.daysUntilRenewal !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "ov-info-key" }, "Dias até renovação", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["ov-info-val", $setup.daysUntilRenewal <= 30 ? 'ov-warn-text' : ''])
                }, _toDisplayString($setup.daysUntilRenewal) + " dias", 3)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _cache[19] || (_cache[19] = _createStaticVNode("<h3 class=\"ov-card-title\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\"></rect></svg> Módulos ativos </h3>", 1)),
        ($setup.flagsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Carregando..."))
          : (_openBlock(), _createElementBlock("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mainFlags, (flag) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: flag.key,
                  class: _normalizeClass(["ov-module-chip", flag.enabled ? 'ov-module-chip--on' : 'ov-module-chip--off'])
                }, _toDisplayString(flag.label), 3))
              }), 128))
            ]))
      ])
    ])
  ]))
}